module.exports = __webpack_public_path__ + "static/img/pt.9175eb18.png";